let DOMParser;

if (typeof window !== 'undefined' && window.DOMParser) {
  // Browser environment
  DOMParser = window.DOMParser;
} else {
  // Node.js environment - DOMParser is not available, handle it differently
  DOMParser = function() {
    throw new Error('DOMParser is not available in Node.js environment.');
  };
}

const extractTextFromHtml = htmlString => {
  let doc;
  try {
    const parser = new DOMParser();
    doc = parser.parseFromString(htmlString, 'text/html');
  } catch (error) {
    // Handle the case where DOMParser is not available
    console.error('DOMParser is not available in this environment.');
    return ''; // or handle it as needed
  }

  // Extract text content from the document
  const textContent = doc.body.textContent || '';

  return textContent;
};

export default extractTextFromHtml;
